/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2023, Zumper
 * @description getUrlFromLocation
 */

import { isValidBounds } from '@zcode/nr-utils'
import type { Location } from '@zcode/state-type'
import { getBoxJS } from '../location'

const FIXED_ID_RE = /fixedId=[lb]\d+/

type LocWithStateUrl = Partial<Location> & { stateUrl?: string }

export const getUrlFromLocation = (location?: LocWithStateUrl) => {
  if (!location) {
    return {
      searchQueries: [],
      path: '/',
    }
  }
  const searchQueries = []
  const { box, stateUrl, url } = location

  const newUrl = url || stateUrl || '/'

  if (isValidBounds(box)) {
    const {
      minLng,
      minLat,
      maxLng,
      maxLat,
    }: { minLng: number; minLat: number; maxLng: number; maxLat: number } = getBoxJS(location)
    searchQueries.push(`box=${minLng},${minLat},${maxLng},${maxLat}`)
  }

  const fullUrl: Location | string = typeof window === 'undefined' ? '' : window.location.href
  const fixedId = FIXED_ID_RE.exec(fullUrl)
  if (fixedId) {
    searchQueries.push(fixedId[0])
  }

  return {
    searchQueries,
    path: newUrl,
  }
}
